<template>
  <div v-if="topics && topics.length > 0">
    <div class="edit-interests-btn" @click="launchEditInterestsModal">
      Edit interests
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditInterestsModal from "./EditInterestsModal";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import { createStandardModal } from "@/utils/modalHelper";

export default {
  name: "edit-interests-button",
  props: ["topics"],
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      modalInstance: null
    };
  },
  watch: {
    getStartedClicked(newVal) {
      if (newVal === true) this.launchEditInterestsModal();
    }
  },
  computed: {
    ...mapGetters(["getStartedClicked"])
  },
  methods: {

    launchEditInterestsModal() {
      this.trackNewsEditInterestsClick();

      // Create modal instance using vue-final-modal v4 API
      this.modalInstance = createStandardModal(EditInterestsModal, {
        props: {
          topics: this.topics
        },
        callbacks: {
          onInterestsSaved: () => {
            this.handleInterestsSaved();
          }
        }
      });

      // Open the modal
      this.modalInstance.open();
    },

    handleInterestsSaved() {
      this.$parent.$emit("interestsSaved");
    },
  },

  beforeUnmount() {
    // Cleanup modal instance when component is destroyed
    if (this.modalInstance) {
      this.modalInstance.destroy();
    }
  }
};
</script>

<style scoped>
.edit-interests-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: #000;
  text-decoration: underline;
}
.edit-interests-btn:hover {
  cursor: pointer;
  color: #000;
}
</style>